import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full bg-black/90 border-t border-white/10">
      <div className="container mx-auto px-4 py-4">
        <p className="text-center text-white/50 text-sm">
          Copyright Hermes hahahahahahahahaha
        </p>
      </div>
    </footer>
  );
};

export default Footer;